import { Component, Element, Host, State, getAssetPath, h } from '@stencil/core';
import { ColorHelper } from '../../utils/color-helpers';

/**
 * @slot - Designed to add custom content inside the footer.
 */
@Component({
  tag: 'sy-footer',
  styleUrl: 'scss/index.scss',
  shadow: true,
  assetsDirs: ['assets'],
})
export class Footer {
  private styleObserver: MutationObserver;

  @Element() el: HTMLSyFooterElement;

  @State() contrastColor: string;

  componentWillLoad() {
    this.getContrastColor();
    this.handleStyleChange();
  }

  componentDidLoad() {
    this.getContrastColor();
    console.warn(
      '<sy-footer> component has been deprecated and will be removed starting from version 2.0.0. Its usage should be replaced by the new component <sy-app-footer> exported by the "SYDLE UI - Basic Components"(@sydle/ui-app-components).',
    );
  }

  disconnectedCallback() {
    this.styleObserver?.disconnect();
  }

  private getContrastColor() {
    const newColor = ColorHelper.getContrastColor(
      window.getComputedStyle(this.el).getPropertyValue('background-color'),
    );
    if (newColor && newColor !== this.contrastColor) {
      this.contrastColor = newColor;
    }
  }

  private handleStyleChange() {
    this.styleObserver = new MutationObserver((mutations) => {
      mutations.forEach(() => {
        this.getContrastColor();
      });
    });
    this.styleObserver.observe(this.el.getRootNode(), { attributes: true, attributeFilter: ['style'], subtree: true });
  }

  render() {
    return (
      <Host>
        <slot></slot>
        <div>
          <span>Powered by </span>
          <a href="https://www.sydle.com/" target="_blank" rel="noreferrer">
            {this.contrastColor === '#FFFFFF' && (
              <img src={getAssetPath(`./assets/logo-sydle-white.svg`)} alt="SYDLE" width="88" height="7" />
            )}
            {this.contrastColor === '#000000' && (
              <img src={getAssetPath(`./assets/logo-sydle-black.svg`)} alt="SYDLE" width="88" height="7" />
            )}
          </a>
        </div>
      </Host>
    );
  }
}
